import { render } from "./UserActivitats.vue?vue&type=template&id=4c4d7ce6"
import script from "./UserActivitats.vue?vue&type=script&lang=js"
export * from "./UserActivitats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__